<template>
    <div class="Artwork" v-if="ready" @touchend="mouseUp()">

        <div id="trigger5" class="Artwork__trigger discover"/>
        <div id="trigger6" class="Artwork__trigger maps"/>
        <div id="trigger7" class="Artwork__trigger autoscroll"/>
        <div id="trigger4" class="Artwork__trigger nav"/>
        <div id="trigger3" class="Artwork__trigger footer"/>
        <div id="trigger2" class="Artwork__trigger motion"/>

        <div class="Artwork__container">
            <div ref="header" class="Artwork__header">  
                <div class="Artwork__image" v-if="element.type == 'artwork'">      
                    <video ref="video" width="100%" height="100%" autoplay loop muted playsinline>
                        <source :src="require('@/commons/videos/'+ element.video +'.mp4')" type="video/mp4" >
                    </video> 
                </div>
                <div class="Artwork__image location" v-if="element.type != 'artwork'">  
                    <img :src="'https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photoreference='+ element.thumb +'&key='+ key">
                </div>
                <div class="Artwork__title" 
                    v-if="element.type == 'artwork' " 
                    v-html="element.name"/>
                <div class="Artwork__title" 
                    :class="[{ 'large': element.id == 6 || element.id == 10 || element.id == 1 }, { 'xlarge': element.id == 12 }]" 
                    v-if="element.type != 'artwork' " 
                    v-html="element.name[this.lang]"/>
                <div class="Artwork__line"/>
                <div class="Artwork__close" @click="onClose()">
                    <img :src="require('@/commons/img/close.png')"/>
                </div>
            </div> 

            <template v-if="element.type == 'artwork'">
                <div class="Artwork__content">    

                    <div class="Artwork__address">
                        <img :src="require('@/commons/img/point.png')"/>
                        <p v-html="element.lieu[this.lang]"/> 
                    </div>

                    <div class="Artwork__title-1">{{ trans('ARTWORK.directions')}}</div>
                    <div v-html="element.directions[this.lang]"/>
                    <!-- <div v-html="trans('ARTWORK.complement')"/> -->
                    <div class="Artwork__title-1" @click="onToggle()">
                        <div>{{ trans('ARTWORK.trouble')}}</div>
                        <img class="Artwork__arrow" :src="require('@/commons/img/expand.png')"/>
                    </div>
                    <div class="Artwork__troubles" v-html="trans('ARTWORK.troubles')" :class="{'active': use_explications }" />
                    <div v-html="element.description[this.lang]"/>

                    <template v-if="element.credits">
                        <div class="Artwork__title-1">{{ trans('ARTWORK.credits')}}</div>
                        <div v-html="element.credits[this.lang]"/> 
                    </template>
                        
                </div> 
                <div id="discover" class="Artwork__discover" :class="{'active': is_active }">
                    <div class="Artwork__discover-block" v-html="trans('ARTWORK.try')"/>
                    <div class="Artwork__discover-block right">
                        <div class="Artwork__discover-button left" @click="onMedia(element.link['instagram'])">    <img :src="require('./img/twitter.png')">
                            <img ref="rf1" :src="require('@/commons/img/reflect.png')" class="Artwork__reflect">
                        </div>
                        <div class="Artwork__discover-button" @click="onMedia(element.link['facebook'])">
                            <img :src="require('./img/fb.png')">
                            <img ref="rf2" :src="require('@/commons/img/reflect.png')" class="Artwork__reflect">
                        </div>
                    </div>
                </div>  
            </template>

            <template v-if="element.type == 'location'">
                <div class="Artwork__content">         
                    <div class="Artwork__address">
                        <img :src="require('@/commons/img/point.png')"/>
                        <p>{{ element.address[this.lang] }}</p>
                    </div>
                    <div class="Artwork__artist" v-html="element.text[this.lang]"/>
                </div> 
            </template>

            <div class="Artwork__hover" @click="onClose()"/>

        </div>
    </div>
</template>

<script>

import Mixin from '@/mixins/Smooth.js'
import Coords from '@/config/Coords.js'
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import MotionPathPlugin from "gsap/MotionPathPlugin"
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, ScrollToPlugin)

export default {
    name: 'Artwork',
    mixins: [ Mixin ],
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        element: null,
        is_active: false,
        ready: false,
        use_explications: false,
        autoscroll: false,
        key: 'AIzaSyCtHkUR3tTBnj9EgGtNCyMj17u6FkFqmLc',
    }),
    beforeDestroy() {    
    },
    computed: {
        id() { return this.$store.getters['app/artwork_used'] },
    },
    watch: {
        'is_active'(nw){
            if(nw == true && this.element.type == 'artwork')
                gsap.timeline()
                    .to(this.$refs.rf1, { left: '120%', scale: 1.2, ease: 'none', duration: .2, delay: 1 })  
                    .to(this.$refs.rf2, { left: '100%', ease: 'none', duration: .2, delay: .1 })  
        }
    },
    mounted() {   

        const idx = _.findKey(Coords.markers, (o)=> { return o.id == this.id })
        this.element = Coords.markers[Number(idx)]
        this.ready = true

        this.$nextTick(()=>{

            this.$scr = ScrollTrigger.create({
                scroller: '.Artwork',
                trigger: '.Artwork__header',
                start: "top 0px",
                end: "+=999999",
                toggleActions: "restart pause reverse pause",
                scrub: true,
                pin: true,
                pinSpacing: false,
                anticipatePin: true,
                pinType: "fixed"
            })
            let timeline = gsap.timeline()
                timeline.add([
                    gsap.to('.Artwork__header', { height : 108, ease: 'none' }),
                    gsap.to('.Artwork__title', { top: 20, ease: 'none' }),
                    gsap.to(".Artwork__image", { alpha: 0, y: -100, ease: 'none', duration: .1 }), 
                    gsap.to(".Artwork__line", .25, { width: '100%', ease: 'none', duration: .05 })  
                ])
            ScrollTrigger.create({
                scroller: '.Artwork',
                trigger: "#trigger2",
                animation: timeline,
                start: "top 0",
                toggleActions: "restart pause reverse pause",
                scrub: true,
                // markers: true
            })
            ScrollTrigger.create({
                scroller: '.Artwork',
                trigger: "#trigger4",
                start: "top 0",
                toggleActions: "restart pause reverse pause",
                scrub: true,
                onLeaveBack: ()=>{
                    gsap.to(".Artwork__image", .25, { 
                        opacity: 0, 
                        ease: 'none', 
                        duration: .25,
                        onComplete: ()=> this.resetIt() 
                    }) 
                }
            })
            ScrollTrigger.create({
                scroller: '.Artwork',
                trigger: "#trigger5",
                start: "top 0",
                toggleActions: "restart pause reverse pause",
                scrub: true,
                onEnter: ()=>{ this.is_active = true },
                onLeaveBack: ()=>{ this.is_active = false }
            })

            ScrollTrigger.create({
                scroller: '.Artwork',
                trigger: "#trigger6",
                start: "top 0",
                toggleActions: "restart pause reverse pause",
                scrub: true,
                onEnter: ()=>{ gsap.set(".Map", { opacity: 0 }) },
                onLeaveBack: ()=>{ gsap.set(".Map", { opacity: 1 }) }
            })

            ScrollTrigger.create({
                scroller: '.Artwork',
                trigger: "#trigger7",
                start: "top bottom",
                toggleActions: "restart pause reverse pause",
                scrub: true,
                onEnter: ()=> { this.autoscroll = false },
                onLeaveBack: ()=>{  this.autoscroll = true },
                // markers: true
            })

            let str = gsap.timeline()
                str.add([
                    gsap.to('.Artwork', {
                        scrollTo: {
                          y: document.querySelector("#trigger3"),
                          autoKill: false
                        },
                        duration: .65,
                        ease: 'back.out',
                        delay: .1
                    }),
                    gsap.from(".Artwork__image", { y: 40, alpha: 0, ease: 'back.out', duration: .25, delay: .6 })  
                ])
        })
    },

    methods: {  

        mouseUp() {
            if(this.autoscroll)
                this.onClose()
        },

        resetIt() {
            this.$store.commit('app/SET_ARTWORK', null)
            this.$router.push({ params: { id: null }})
        },
        onToggle() {
            this.use_explications = !this.use_explications
            const angle = this.use_explications ? 90 : 0
            gsap.to(".Artwork__arrow", { rotation: angle, ease: 'cubic.out', duration: .25 })
        },

        onMedia(target) {
            if(target)
                window.open(target, '_blank')
        },

        onClose() {
            let str = gsap.timeline()
                str.add([
                    gsap.to('.Artwork', {
                        scrollTo: {
                          y: -200,
                          autoKill: true
                        },
                        duration: .5,
                        ease: 'cubic.easeOut',
                        onComplete: ()=> this.resetIt()
                    }),
                    gsap.to(".Artwork__image", .25, { opacity: 0, ease: 'none', duration: .25 })  
                ])
        }
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Artwork 
    position fixed
    top 0
    left 0
    width 100vw
    height 100%
    overflow scroll

    &__container
        margin-top 100vh
        min-height 125vh
        background white

    &__header
        width 100vw   
        height 186px
        border-bottom 1px solid white
        background white
        display flex
        align-items center
        justify-content center
        position absolute
        z-index 20

    &__image 
        // width 230px
        // height 144px
        // background grey
        // position absolute
        // opacity 0
        // left 30px
        // top -77px

        width 124px
        height 220px
        position absolute
        opacity 1
        left 30px
        top -150px

        &.location 
            background grey
            width 220px
            height 124px
            top -62px 

            & img
                width 220px
                height 124px

    &__title 
        font-family Jugendreisen
        font-size 24px
        text-transform uppercase
        position absolute
        top 92px
        left 30px
        width 75%

        & span 
            border-bottom-width: 1px
            border-bottom-style: solid
            text-decoration: none

        &.large
            font-size 20px
            top 100px

        &.xlarge
            font-size 19px
            top 110px

    &__title-1
        font-family Ringside
        font-size 16px
        font-weight 700
        padding 16px 0px 14px 0
        display flex
        align-items center
        justify-content space-between

    p 
        font-family Ringside
        font-size 16px
        line-height 20px
        font-weight 200
        margin 0 0 16px

    ul
        padding 0 0 0 32px
        list-style-image url('./img/line.png')
        list-style-position outside
      
        li
            font-family Ringside
            font-size 16px
            font-weight 200
            padding 0 0 8px 8px

    &__line
        background black
        width 0%
        height 1px
        position absolute
        bottom 0
        left 0

    &__close 
        position absolute
        top 24px
        right 16px

    &__content
        position relative
        background white
        padding 196px 30px 22vh
        margin-top 200px
        z-index 3

    &__troubles 
        height 0
        overflow hidden
        transition height .5s 
        margin-bottom 16px

        &.active
            height 420px

    &__discover
        position fixed
        background rgb(245,180,197)
        background linear-gradient(90deg, rgba(163,187,190,1) 0%, rgba(203,205,212,1) 65%, rgba(230,218,222,1) 100%)
        height 74px
        bottom 48px
        width calc(100% - 30px)
        left 50%
        transition opacity .25s, transform .25s
        transform translate(-50%, -20px)
        opacity 0
        z-index 10
        font-family Ringside
        font-size 12px
        color white
        text-transform uppercase
        display flex
        align-items center
        justify-content space-between

        &.active
            opacity 1
            transform translate(-50%, 0)

        &-block 
            padding 16px
            line-height 15px

            &.right 
                display flex
                flex-direction rows
                justify-content flex-end

        &-button 
            background white
            border-radius 20px
            width 48px
            height 46px
            display flex 
            align-items center 
            justify-content center
            cursor pointer
            overflow hidden
            position relative

            &.left 
                margin-right 12px

    &__reflect 
        position absolute
        left -100%

    &__trigger
        width 80vw
        height 5px
        z-index 200
        pointer-events none
        // border-bottom 1px solid red

        &.footer
            position absolute
            top 65vh

        &.discover
            position absolute
            top 50vh

        &.nav
            position absolute
            top 20px

        &.motion
            position absolute
            height 186px
            top calc(100vh)

        &.maps
            position absolute
            top 125vh

        &.autoscroll
            position absolute
            top 130vh
            // border 1px solid yellow

    &__address
        display flex 
        flex-direction row
        align-items center

        & p 
            margin-left 20px 
            line-height 18px

        & img
            width 13px 
            height 23px
            padding-bottom 16px

    &__artist 
        padding-top 16px

    &__hover 
        position absolute
        width 100%
        height 200vh
        top 0
        cursor pointer

</style>










